// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1O1Pb","info":"UpdateTermsInfo_info__2Ybe3"};